import { render, staticRenderFns } from "./examens.html?vue&type=template&id=4e9060f9&scoped=true&external"
import script from "./examens.js?vue&type=script&lang=js&external"
export * from "./examens.js?vue&type=script&lang=js&external"
import style0 from "./examens.scss?vue&type=style&index=0&id=4e9060f9&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9060f9",
  null
  
)

export default component.exports